export default function deprecate(message, options = {}) {
    if (options.predicate) {
        return;
    }
    let returnMessage = message;
    if (options.until && options.package) {
        returnMessage = message.concat(`\n\nThis API will be removed from ${options.package}@${options.until}.`);
    }
    if (options.url) {
        returnMessage = returnMessage.concat(`\n\nSee ${options.url} for more details.`);
    }
    // tslint:disable-next-line:no-console
    console.warn(`DEPRECATION: ${returnMessage}`);
}
//# sourceMappingURL=deprecate.js.map